const kpiSummaryReportRoute = {
    BASE_PATH: "/reports/kpi-summary",
}

export default kpiSummaryReportRoute;